// The plant's Supplier Request form as data: its fields, what a saved draft turns into, and what
// has to be filled in before it can be printed for the plant head. Pure, so the rules are
// unit-tested (requestForm.test.js).
import { EMPTY_CLASSIFICATION, classificationOf, isClassified } from '../../utils/classification.js';

export const EMPTY_FORM = {
  user_name: '',
  user_site_plant: '',
  required_vendor_name: '',
  vendor_contact: '',
  vendor_email: '',
  ...EMPTY_CLASSIFICATION,
  reason_for_new_vendor: '',
  requested_by: '',
};

const TEXT_FIELDS = {
  user_name: 'User Name',
  user_site_plant: 'User Site & Plant',
  required_vendor_name: 'Required Vendor Name',
  vendor_contact: 'Vendor Contact',
  vendor_email: 'Vendor Email',
  reason_for_new_vendor: 'Reason for creating a new vendor code',
  requested_by: 'Requested By',
};

// The same three questions, with the same wording, as the Invite Vendor form.
const CHOICE_MESSAGES = {
  nature_of_business: 'Choose the nature of business',
  oem_odm: 'Choose OEM or ODM',
  supplier_subcategory: 'Choose the supplier sub-category',
};

/** The form for a saved draft: every field present, '' where the draft has nothing yet. */
export const formFromDraft = (draft) => ({
  user_name: draft?.user_name || '',
  user_site_plant: draft?.user_site_plant || '',
  required_vendor_name: draft?.required_vendor_name || '',
  vendor_contact: draft?.vendor_contact || '',
  vendor_email: draft?.vendor_email || '',
  ...classificationOf(draft),
  reason_for_new_vendor: draft?.reason_for_new_vendor || '',
  requested_by: draft?.requested_by || '',
});

/** Field → message for everything still wrong; an empty object when the form can be printed. */
export const validateRequestForm = (form) => {
  const errors = {};
  for (const [field, label] of Object.entries(TEXT_FIELDS)) {
    if (!String(form?.[field] ?? '').trim()) errors[field] = `${label} is required`;
  }
  if (form?.vendor_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.vendor_email.trim())) {
    errors.vendor_email = 'Please enter a valid email address';
  }
  for (const [field, message] of Object.entries(CHOICE_MESSAGES)) {
    if (!form?.[field]) errors[field] = message;
  }
  return errors;
};

/**
 * A draft saved before the form asked what the supplier is. It cannot be submitted until those
 * three answers are given, so the signed document is not asked for first.
 */
export const needsClassification = (draft) => !isClassified(draft);

export const CLASSIFICATION_FIRST =
  'Choose the nature of business, supplier type and sub-category first — they are now part of the request.';
